/* eslint-disable @reatom/unit-naming-rule */
import { userTradingAnalyticsPeriodAtom } from '@root/features/user/user-trading-analytics/atoms'
import { reatomResource } from '@root/shared/lib'

import { windowOf } from '../model'

import { fetchWalletProfileRequestAction } from './wallet-profile-requests'

import type { Address } from '@root/entities/address/Address'
import type { Network } from '@root/entities/network'

/**
 * A wallet's profile, fetched when something connects to it.
 *
 * `loadOnConnect` is what makes the modal load on opening: the dialog mounts
 * its content only while there is a wallet to show, so connecting is opening.
 */
export const reatomWalletProfile = ({
  network,
  walletAddress,
}: {
  network: Network.Network
  walletAddress: Address
}) =>
  reatomResource(
    // Not an async body: the spy below has to be seen by the reaction that
    // runs this, and an async function hands control back before it is.
    (ctx) => {
      // Spied, not read: the period selector above the dashboard decides the
      // window, and before this it decided nothing — the request carried a
      // fixed thirty days whatever the reader picked.
      const window = windowOf(ctx.spy(userTradingAnalyticsPeriodAtom))

      return ctx.schedule(() =>
        fetchWalletProfileRequestAction(ctx, {
          network,
          walletAddress,
          window,
        }),
      )
    },
    { loadOnConnect: true },
  )

export type WalletProfileRequestModel = ReturnType<typeof reatomWalletProfile>
